import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BaseDataService } from '../base-data/base-data.service';
import { Options } from '../base-data/_models/base-data-options.model';
import { Secure } from '../../enums/secure.enum';
import { UrlUtil } from '../../util/url/url.util';
import { ErrorDialogService } from '../../dialogs/error/error-dialog.service';
import { LoginRequest } from '../../models/authentication/login-request.model';
import { BaseUser } from '../../models/base-user/base-user.model';
import { BaseNewUserRequest } from '../../models/base-user/base-new-user-request.model';
import { LeathermanAppConfigInjectionToken } from '../../config/injection-tokens/leatherman-app-config.injection-token';
import { ILeathermanAppConfig } from '../../config/app.config';
import { ErrorDialogServiceInjectionToken } from '../../config/injection-tokens/error-dialog-service.injection-token';
import { Status } from '../../enums/status.enum';
import { AuthenticationDetails } from '../../models/authentication/authentication-details.model';

/**
 * A service for communicating with the server's authentication endpoints
 */
@Injectable({
  providedIn: 'root'
})
export class AuthenticationDataService extends BaseDataService {
  /**
   * Constructor
   * @param config - The app config object
   * @param errorDialogService - A reference to the error dialog service
   * @param router - A reference to the router
   * @param httpClient - A reference to the HTTP client
   */
  constructor(
    @Inject(LeathermanAppConfigInjectionToken) config: ILeathermanAppConfig,
    @Inject(ErrorDialogServiceInjectionToken)
    errorDialogService: ErrorDialogService,
    router: Router,
    httpClient: HttpClient
  ) {
    super(config, errorDialogService, router, httpClient);
  }

  // /**
  //  * Get a JWT token
  //  * @param loginRequest - The login request object
  //  * @returns A JWT token
  //  * @async
  //  */
  // public async getToken<T extends LoginRequest>(loginRequest: T): Promise<string> {
  //   const options = new Options();
  //   options.url = UrlUtil.join(this.apiRoot, 'gettoken');
  //   options.secure = Secure.false;
  //   options.validateId = false;
  //   options.suppressedErrors.push(Status.NotAuthorized);
  //   const token = await this._postWithOptions<string>(
  //     loginRequest,
  //     options
  //   ).catch(async err => {
  //     return await this.handlePromiseError(
  //       'AuthenticationDataService',
  //       'getToken',
  //       err
  //     );
  //   });
  //   return token;
  // }

  public async authenticate<T extends LoginRequest>(
    loginRequest: T
  ): Promise<AuthenticationDetails> {
    const options = new Options();
    options.url = UrlUtil.join(this.apiRoot, 'authenticate');
    options.secure = Secure.false;
    options.validateId = false;
    options.suppressedErrors.push(Status.NotAuthorized);
    console.log('About to authenticate');
    const authenticationDetails = await this._postWithOptions<
      AuthenticationDetails
    >(loginRequest, options).catch(async err => {
      console.log(err);
      return await this.handlePromiseError(
        'AuthenticationDataService',
        'authenticate',
        err
      );
    });
    console.log('Authentication details');
    console.log(authenticationDetails);
    return authenticationDetails;
  }

  /**
   * Register a new user
   * @param newUserRequest - A new user request object
   * @param secure - An enum indicating whether the endpoint is secure
   */
  public async register<T extends BaseNewUserRequest, U extends BaseUser>(
    newUserRequest: T,
    secure: Secure
  ): Promise<U> {
    const options = new Options();
    options.url = UrlUtil.join(this.apiRoot, this.config.registerRoute);
    options.secure = secure;
    options.validateId = false;
    const user = await this._postWithOptions<U>(newUserRequest, options).catch(
      async err => {
        return await this.handlePromiseError(
          'AuthenticationDataService',
          'register',
          err
        );
      }
    );
    return user;
  }
}
